<template>
	
	<div class="testbg">
		
		
		<div class="home_all" :class="this.layout.is_phone?'home_all_phone':''">
			
			<!-- 登錄明细 收支统计 -->
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
			
					<el-col  :span="layout.is_phone?24:12" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>{{$t('home.info')}}</span>
							</div>
							
							
							<div class="w-100 align-content-center" style="height: 100px; ">
								<el-row class="w-100">
									<el-col :span="8" v-if="!layout.is_phone || layout.user.type==2">
										<div style="display: flex;align-items: center;">
											<el-avatar :size="45" :src="layout.user.head?layout.user.head:layout.user_mo"></el-avatar>
											
											<div  class="ml-3">
												<div class="mb-1">{{layout.user.name}}</div>
												<div style="color: #999;">{{layout.user.username}}</div>
											</div>
											
										</div>
										
									</el-col>
									<el-col :span="layout.is_phone?12:8" v-if="layout.user.type==1">
										<div>
											<div class="mb-2"><i class="iconfont icon-dailishang mr-2"></i>{{$t('home.agent_num')}}</div>
											<div class="text_chengse">{{total_list.agent_num}}</div>
										</div>
									</el-col>
									
									<el-col :span="layout.is_phone?12:8" v-if="layout.user.type==2">
										<div>
											<div class="mb-2">
												<i class="iconfont icon-qianbao1 mr-2"></i>{{$t('home.my_money')}}
												<!-- 在线充值 -->
												<!-- <el-button type="success" class="ml-2" size="mini" @click="openPayModel()" >{{$t('layout.pay')}}</el-button> -->
												</div>
											<div class="text_chengse">
												<span>$ {{total_list.my_money}}</span>
												
												
											</div>
										</div>
									</el-col>
									<el-col :span="layout.is_phone?12:8">
										<div  class="mb-2"><i class="iconfont icon-kehuliebiao1 mr-2"></i>{{$t('home.user_num')}}</div>
										<div class="text_chengse">{{total_list.user_num}}</div>
									</el-col>
									
									
								</el-row>
							</div>
							
						</el-card>
					</el-col>
					
					
					<el-col  :span="layout.is_phone?24:12" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>{{$t('home.total_data')}}</span>
							</div>
							
							<!-- 统计图容器 -->
							<div class="w-100 align-content-center" style="height: 100px; ">
								<el-row class="w-100">
									<el-col :span="8">
										<div style="display: flex;align-items: center;">
											<div>
												<div class="mb-2"><i class="iconfont icon-dailishang mr-2"></i>{{$t('home.total')}}</div>
												<div class="text_chengse">{{total_list.total_money}}</div>
											</div>
											
										</div>
										
									</el-col>
									<el-col :span="8" >
										<div>
											<div class="mb-2"><i class="iconfont icon-dailishang mr-2"></i>{{$t('home.mon')}}</div>
											<div class="text_chengse">{{total_list.mon_money}}</div>
										</div>
									</el-col>
									<el-col :span="8">
										<div  class="mb-2"><i class="iconfont icon-kehuliebiao1 mr-2"></i>{{$t('home.zuo')}}</div>
										<div class="text_chengse">{{total_list.zuo_money}}</div>
									</el-col>
								</el-row>
							</div>
							
						</el-card>
					</el-col>

			</el-row>
			
			
			<!-- 返佣数据 -->
			<el-row v-if="layout.user.type==2" :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
			
					
					
					
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>{{$t('home.rebateData')}}</span>
							</div>
							
							<!-- 统计图容器 -->
							<div class="w-100 align-content-center" style="height: 100px; ">
								<el-table :data="rebateData" style="width: 100%" size="mini" >
									
									
									<el-table-column align="center" prop="type" :label="$t('aglevel.type')">
										<template slot-scope="scope">
											<span v-if="scope.row.type==1">{{$t('aglevel.domain')}}</span>
										</template>
									</el-table-column>
									
									<el-table-column align="center"  prop="name" :label="$t('aglevel.aglevel')">
									</el-table-column>
									
									
									
									
								    <el-table-column align="center" prop="rebate" :label="$t('aglevel.rebate')">
										<template slot-scope="scope">
											{{scope.row.rebate}} %
										</template>
									</el-table-column>
									<el-table-column align="center" prop="rebate" :label="$t('aglevel.code')">
										<template slot-scope="scope">
											{{scope.row.code}} <span class="iconCopy" @click="copyText(scope.row.code)"><i class="iconfont icon-fuzhi"></i></span>
										</template>
									</el-table-column>
								    <el-table-column align="center" prop="rebate" :label="$t('aglevel.regUrl')" width="360">
										<template slot-scope="scope">
											<span style="color: #409eff;">{{scope.row.url}}</span> <span class="iconCopy" @click="copyText(scope.row.url)"><i class="iconfont icon-fuzhi"></i></span>
										</template>
									</el-table-column>
									
									
									
									
									
								</el-table>
							</div>
							
						</el-card>
					</el-col>
			
			</el-row>
			
			
			<el-row :gutter="layout.index_p.gutter" class="h_1" >
					<!-- 左边 -->
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span><i class="iconfont icon-yujing1 mr-2"></i>{{$t('home.user_warn')}} （{{warn_list.length}})</span>
								</div>
								<el-table  v-if="warn_list.length!=0"
								   	height="230"
								    :data="warn_list" 
								    style="width: 100%;">
									<el-table-column align="center" type="index" label="排序" >
									  </el-table-column>
								      <el-table-column align="center"  width="100"
								        prop="name"
								        :label="$t('userInfo.name')"
								        >
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
											
										</template>
								      </el-table-column>
									  
									  <el-table-column width="100" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
									  </el-table-column>
									  
									  
									  			
									  
									  <el-table-column show-overflow-tooltip="" align="center" width="100" prop="username" :label="$t('model.yunAccount')">
									  </el-table-column>
								      <el-table-column
									  show-overflow-tooltip=""
								        prop="title" align="center" 
								        :label="$t('home.warn_info')"
								        >
										<template slot-scope="scope">
											<div class="text-danger">
												<i class="iconfont icon-yujing1 mr-2"></i>
												<span>{{scope.row.title}}</span>
											</div>
											
										</template>
								      </el-table-column>
									  
									  
									  <el-table-column
									    prop="create_time" align="center" 
									    :label="$t('home.warn_time')"
									    >
								
									  </el-table-column>
									  
									  <el-table-column
									    prop="ip" align="center"
									    :label="$t('layout.operation')">
										
										<template slot-scope="scope">
											<el-button-group>
												<el-button  :disabled="scope.row.status!=0" @click="clearWarn(scope.row.id)"  size="mini" plain type="success">{{$t('home.is_c')}}</el-button>
												
												
											</el-button-group>
										</template>
										</el-table-column>
									 
								
								    </el-table>
									
									<el-empty v-else :description="$t('home.no_data')" :image-size="80"></el-empty>
									
									
									
							</el-card>
							
						</el-col>
					
					
					
			</el-row>
			
			
			
			
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
			
					<el-col  :span="layout.is_phone?24:12" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<i class="iconfont icon-tengxunyun1 mr-2"></i><span>{{$t('home.txYunGj')}}</span>
							</div>
							
							
							<div class="w-100 " style="height: 165px; overflow-y: auto;">
								 <el-table v-if="yun_list.txYunGj" class="no_head_table"
								      :data="yun_list.txYunGj"
								      style="width: 100%">
									  
									  <el-table-column  align="center" type="index" :label="$t('adminList.sort')" width="50">
										  
									  </el-table-column>
								      <el-table-column
								        prop="username"
								        label="云账户"
								        >
								      </el-table-column>  
										
									<el-table-column
								        prop="username"
								        label="用户"
								        >
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
											
										</template>
								      </el-table-column>
									  
									  <el-table-column
									    prop="day"
									    label="欠费天数"
									    >
										<template slot-scope="scope">
											<span> 欠费{{scope.row.day}}天</span>
										</template>					
									  </el-table-column>
								      <el-table-column
								        prop="need_money"
								        label="欠费"
								        >
										<template slot-scope="scope">
											<span class="text_chengse"> - {{scope.row.need_money}}</span>
										</template>
								      </el-table-column>
								    
								    </el-table>
									<el-empty v-else :description="$t('home.no_data')" :image-size="40"></el-empty>
							</div>
							
						</el-card>
					</el-col>
					
					
					<el-col  :span="layout.is_phone?24:12" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<i class="iconfont icon-huaweiyun mr-2"></i><span>{{$t('home.hwYun')}}</span>
							</div>
							
							
							<div class="w-100 " style="height: 165px; overflow-y: auto;">
								 <el-table v-if="yun_list.hwYun" class="no_head_table"
								      :data="yun_list.hwYun"
								      style="width: 100%">
									  
									  <el-table-column  align="center" type="index" :label="$t('adminList.sort')" width="50">
										  
									  </el-table-column>
								      <el-table-column
								        prop="username"
								        label="云账户"
								        >
								      </el-table-column>  
										
									<el-table-column
								        prop="username"
								        label="用户"
								        >
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
											
										</template>
								      </el-table-column>
									  
									  <el-table-column
									    prop="day"
									    label="欠费天数"
									    >
										<template slot-scope="scope">
											<span> 欠费{{scope.row.day}}天</span>
										</template>					
									  </el-table-column>
								      <el-table-column
								        prop="need_money"
								        label="欠费"
								        >
										<template slot-scope="scope">
											<span class="text_chengse"> - {{scope.row.need_money}}</span>
										</template>
								      </el-table-column>
								    
								    </el-table>
									<el-empty v-else :description="$t('home.no_data')" :image-size="40"></el-empty>
							</div>
							
						</el-card>
					</el-col>
			
			</el-row>
			
			
			
			
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
			
					<el-col  :span="layout.is_phone?24:12" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<i class="iconfont icon-amazonaws mr-2"></i><span>{{$t('home.awsYun')}}</span>
							</div>
							
							
							<div class="w-100 " style="height: 165px; overflow-y: auto;">
								 <el-table v-if="yun_list.awsYun" class="no_head_table"
								      :data="yun_list.awsYun"
								      style="width: 100%">
									  
									  <el-table-column  align="center" type="index" :label="$t('adminList.sort')" width="50">
										  
									  </el-table-column>
								      <el-table-column
								        prop="username"
								        label="云账户"
								        >
								      </el-table-column>  
										
									<el-table-column
								        prop="username"
								        label="用户"
								        >
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
											
										</template>
								      </el-table-column>
									  
									  <el-table-column
									    prop="day"
									    label="欠费天数"
									    >
										<template slot-scope="scope">
											<span> 欠费{{scope.row.day}}天</span>
										</template>					
									  </el-table-column>
								      <el-table-column
								        prop="need_money"
								        label="欠费"
								        >
										<template slot-scope="scope">
											<span class="text_chengse"> - {{scope.row.need_money}}</span>
										</template>
								      </el-table-column>
								    
								    </el-table>
									<el-empty v-else :description="$t('home.no_data')" :image-size="40"></el-empty>
							</div>
							
						</el-card>
					</el-col>
					
					
					<el-col  :span="layout.is_phone?24:12" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<i class="iconfont icon-aliyun1 mr-2"></i><span>{{$t('home.aliYun')}}</span>
							</div>
							
							
							<div class="w-100 " style="height: 165px; overflow-y: auto;">
								 <el-table v-if="yun_list.aliYun" class="no_head_table"
								      :data="yun_list.aliYun"
								      style="width: 100%">
									  
									  <el-table-column  align="center" type="index" :label="$t('adminList.sort')" width="50">
										  
									  </el-table-column>
								      <el-table-column
								        prop="username"
								        label="云账户"
								        >
								      </el-table-column>  
										
									<el-table-column
								        prop="username"
								        label="用户"
								        >
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
											
										</template>
								      </el-table-column>
									  
									  <el-table-column
									    prop="day"
									    label="欠费天数"
									    >
										<template slot-scope="scope">
											<span> 欠费{{scope.row.day}}天</span>
										</template>					
									  </el-table-column>
								      <el-table-column
								        prop="need_money"
								        label="欠费"
								        >
										<template slot-scope="scope">
											<span class="text_chengse"> - {{scope.row.need_money}}</span>
										</template>
								      </el-table-column>
								    
								    </el-table>
									<el-empty v-else :description="$t('home.no_data')" :image-size="40"></el-empty>
							</div>
							
						</el-card>
					</el-col>
			
			</el-row>
			
			
			<el-row :gutter="layout.index_p.gutter" class="h_1 mb-3" >
					<!-- 左边 -->
			
					<el-col  :span="24" class=" h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>{{$t('home.yearData')}}</span>
								</div>
								
									
								<div ref="myChart" style="height: 300px;">
									
								</div>
									
							</el-card>
							
						</el-col>
			</el-row>

			
			<el-row :gutter="layout.index_p.gutter" class="h_1" >
					<!-- 左边 -->
			
					<el-col  :span="24" class=" h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>{{$t('home.log')}}</span>
								</div>
								<el-table
								   	height="330"
								    :data="tableData" 
								    style="width: 100%;">
									<el-table-column align="center" type="index" :label="$t('adminList.sort')" >
									  </el-table-column>
								      <el-table-column align="center" 
								        prop="create_time"
								        :label="$t('home.login_time')"
								        >
								      </el-table-column>
								      <el-table-column
								        prop="browse" align="center" 
								        :label="$t('home.llq')"
								        >
								      </el-table-column>
									  
									  <el-table-column
									    prop="ip" align="center"
									    :label="$t('home.ip')">
										</el-table-column>
									  <el-table-column
									    prop="sysversion" align="center"
									    :label="$t('home.system')">
									  </el-table-column>
								
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
										 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
										</el-pagination>
									</div>
									
							</el-card>
							
						</el-col>
					
					
					
			</el-row>
			
					
			<!-- <div v-if="this.layout.is_phone">.</div> -->
			
		</div>
	
		
		
		
		
	
		<!-- 充值弹窗 -->
		<el-dialog :close-on-click-modal="false"
			:title="$t('layout.pay')"
			:visible.sync="payModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="payData" :label-width="layout.is_phone?'80px':'100px'">
				

		        <el-form-item :label="$t('upay.money')" prop="money">
					<el-input v-model="payData.money"  :placeholder="$t('upay.money')" clearable size="small" style="width: 85%;" type="number"
					@input="onMoneyInput"
					  @blur="onMoneyBlur"
					>
					<template slot="append">USDT</template>
					</el-input>
					<div style="color: gray;font-size: 12px;">{{$t('upay.tis')}}</div>
				</el-form-item>
		        <el-form-item :label="$t('upay.remark')" prop="remark">
					<el-input v-model="payData.remark"  maxlength="255" :placeholder="$t('upay.remark')" clearable size="small" style="width: 85%;" ></el-input>
				</el-form-item>
				
				
		        
		        
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="payModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="subUpay">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>
		
	
	
		
		
		

	

	</div>
</template>

<script>
	//图形统计导入
	import common from '@/common/mixins/common.js';
	import echarts from 'echarts'
	import { mapState } from 'vuex';
	export default {
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				payModel:false,
				payData:{
					money:"",
					remark:''
				},
				rebateData:[],
				year:null,
				preUrl: "user/homeData", //列表地址
				tableData: [],
				shoplist: {},
				yun_list: [],
				counts: [],
				warn_list: [],
				total_list:{agent_num:0,user_num:0,total_money:0,mon_money:0,zuo_money:0},
				mtCheck:0,
				mtMoney:'',
				

				year_data:[],
				tableData:[],
				createModel:false,
				edit_title:'',
				addUrl: "user/editTxUrl", //修改提现地址
				form:{
					url:'',
					type:0
				},
				
				search:{
					date:''
				},
				
				rules: {
					money: [{
							required: true,
							message: this.$t('upay.inpmoney'),
							trigger: 'blur',
						},
					]
				},
				
				order_list:[],
				sq_info:{
					'tk':{
						'status':0,
						'time':'',
						'url':''
					},
					'se':{
						'status':0,
						'time':'',
						'url':''
					},
					'la':{
						'status':0,
						'time':'',
						'url':''
					}
				}
			
			}
		},
		filters: {
			getCol(total) {
				return `col-${12/total}`
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		//dom渲染完毕 
		mounted() {
			localStorage.setItem('domainDetail', '');
			localStorage.setItem('buyserver', '');
			localStorage.setItem('commonDetailPage', '');
			//画统计图
			//this.drawLine()
		},
		methods: {
			
			  subUpay(){
				  this.$refs.form.validate(res => {
				  	if (res) {
				  		this.subUpayApi()
				  		
				  	}
				  })
			  },
			  subUpayApi(){
			  	this.$confirm(this.$t('upay.confrim_warn')+this.payData.money+' USDT '+this.$t('upay.confrim_warn2'), this.$t('system.prompt'), {
			  		confirmButtonText: this.$t('system.confirm'),
			  		cancelButtonText: this.$t('system.cancel'),
			  		type: 'warning'
			  	}).then(() => {
			  		this.layout.loading = true;
			  		let url = '/admin/user/submitUpay'
			  		this.axios.post(url, this.payData, {
			  			token: true,
			  			loading: true
			  		}).then(res => {
			  	
			  			this.$message({
			  				message: res.data.msg,
			  				type: 'success'
			  			});
			  			this.getList()
			  			this.layout.getPageNum()
			  			this.layout.loading = false;
			  		}).catch(err => {
			  			this.layout.loading = false;
			  		})
			  	})
			  },
			openPayModel(){
				this.payModel = true
			},
			async fetchData() {
				if (!this.year) return;
				try {
					this.search.date = this.year 
					this.getList()
				} catch (error) {
					console.error('查询接口出错:', error);
				}
			},
			updateHomeTime(){
				this.page.current = 1
				this.getList()
			},
		submit(type) {
				this.$refs.form.validate(res => {
					if (res) {
						this.addOrEdit(this.form)
						
					}
				})
				
				
			},
			getListResult(e) {
				this.page.total = e.total
				this.tableData = e.log_list
				if(this.page.current==1){
					this.total_list = e.total_list
					this.warn_list = e.warn_list
					this.yun_list = e.yun_list
					this.year_data = e.year_data
					this.rebateData = e.rebateData
					
				}
				
				
				this.drawLine()
			

			},
			
	
			
					
		
			
			
			
			
			drawLine() {
			  const rawData = this.year_data.data;
			
			  const colors = this.year_data.color; // 5种颜色
			
			  const grid = {
			    left: 50,
			    right: 50,
			    top: 50,
			    bottom: 20
			  };
			
			  const series = this.year_data.name.map((name, sid) => {
			    return {
			      name,
			      type: "bar",
			      stack: "total",
			      barWidth: "60%",
			      label: {
			        show: false, // ❌ 柱子上不显示数值
			      },
			      itemStyle: {
			        color: colors[sid], // 🎨 自定义柱子颜色
			      },
			      data: rawData[sid], // 直接使用原始数据
			    };
			  });
			
			  // 计算 tooltip 百分比
			  const tooltipFormatter = (params) => {
			    let total = 0;
			    params.forEach((item) => {
			      total += item.value;
			    });
			    return params
			      .map(
			        (item) =>
			          `${item.marker} ${item.seriesName}: ${item.value} (${(
			            (item.value / total) *
			            100
			          ).toFixed(2)}%)`
			      )
			      .join("<br/>");
			  };
			
			  // 初始化 ECharts 实例
			  let myChart = echarts.init(this.$refs.myChart);
			
			  // 设置配置项
			  myChart.setOption({
			    tooltip: {
			      trigger: "axis",
			      formatter: tooltipFormatter, // ✅ 鼠标悬停时显示数值 + 百分比
			    },
				
				toolbox: {
				  feature: {
				    dataView: { show: true, readOnly: false ,title:this.$t('tool.data')},
				    magicType: { show: true, type: ["line", "bar"],title:{
						line:this.$t('tool.line'),
						bar:this.$t('tool.bar')
					} },
				    restore: { show: true ,title:this.$t('tool.restore')},
				    saveAsImage: { show: true,title:this.$t('tool.down_img') }
				  }
				},
			    legend: {
			      selectedMode: true,
			    },
			    grid,
			    yAxis: {
			      type: "value",
			    },
			    xAxis: {
			      type: "category",
			      data: this.year_data.year,
			    },
			    series,
			  });
			},

			
			
			
			clearWarn(id){
				this.$confirm(this.$t('home.confrim_warn'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					let url = '/admin/data/editStatusWarn'
					this.axios.post(url, {
						id: id,
					}, {
						token: true,
						loading: true
					}).then(res => {
				
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.getList()
						this.layout.getPageNum()
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			
			
			
			startLine(){
				console.log(startLine)
			},
			
			
			
	
			//前往修改页面
			toView(name) {
				for (var i = 0; i < this.layout.navBar.list.length; i++) {
					
					let index = this.layout.navBar.list[i].submenu.findIndex(v => v.pathname == name);
					if(index!=-1){
						this.layout.navBar.active = i;
						// 跳转到當前激活
						this.layout.slideMenuActive = index
						break
					}
				}
				this.$router.push({
					name: name,

				})
			},
			// 打开模态框
			openModel(e, type) {
				// console.log(e)
				this.edit_title = '修改'+e.desc
				// 修改
				this.form = {
					url: e.num,
					type:e.o_type
				}
			
				// 打开dialog
				this.createModel = true
			}
			
			
		}
	}
</script>

<style>
	.index_btn{
		display: flex; align-items: center;justify-content: space-between;
	}
	.index_btn_left{
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		width: 45px;
		height: 45px;
		
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.index_btn_left2{
		background-color: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	.index_btn_left3{
		background-color: #3b8ff3;
		box-shadow: 0 3px 18px -8px #3b8ff3;
	}
	.index_btn_name{
		font-size: 20px;
	}
	.index_btn_info{
		font-size: 13px;color: #aaa;
	}
	
	.index_btn_ft28{
		font-size: 28px;
	}
	
	
	
	.new_home_p{
		font-size: 15px;
		font-weight: bolder;
		color: #333;
		margin-left: 10px;
	}
	.head_row .el-card__body{
		padding: 15px 10px;
	}
	

	.htr_main{
		display: flex;align-items:center;flex-direction: column;justify-content: center;
	}
	.htr_view{
		display: flex;align-items: center;
		justify-content: space-between;
		
		
		
		
		width: 100%;
	}
	.htr_top{
		border-radius: 5px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		
	}
	.htr_top_new{
	}
	
	.htr_info{
		font-size: 14px;color: #92c0e9;
		
	}
	.htr_desc{
		color: #fff;font-size: 13px;
		text-align: right;
	}
	.htr_icon{
		width: 45px;height: 45px;color: #fff;
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.htr_icon i{
		font-size: 25px;
	}
	.htr_icon_red{
		background: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	
	
	
	.testbg{
		padding: 0px;
		height: 100%;
	}
	.home_all{
		color: #fff;
		height: calc(100% - 130px);
		
	}
	
	.testbg .el-card__header{
		padding: 10px 20px;
		font-size: 15px;
	}
	.new_card .el-card__body{
		height: calc(100% - 44px);
	}
	.zj_card .el-card__body{
		height: 100%;
	}
	.h_100{
		height: 100%;
	}
	.h_50{
		height: 50%;
	}
	.h_l{
		height: auto;
	}
	.h_r{
		height: auto;
	}
	
	
	.home_all_phone .h_l,.home_all_phone .h_r{
		height: auto;
	}
	/* 新选项數据 */
	.new_head_nav{
		display: flex;align-items: center;
	}
	
	.new_head_nav_icon{
		width: 45px;
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		color: #fff;
		
	}
	
	.new_head_nav_icon i{
		font-size: 25px;
	}
	
	.new_info_div{
		display: flex;
		width: 100%;
		justify-content: space-between;
	}
	.new_head_right{
		flex: 1;
	}
	.new_info{
		color: grey;
		font-size: 13px;
	}
	
	.new_head_num{
		color: #222;
		font-size: 25px;
		margin: px 0;
	}
	
	
	/* 新选项數据 */
	
	.no_head_table .has-gutter{
		display: none!important;
	}
	
</style>
